import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { MeetingDetailItemObject } from '../constants/meetings';




type MeetingsState = {
  items: Array<MeetingDetailItemObject>,
  loading: boolean,
  page: number,
  specialPage: number,
  count: number,
  tenantId: number | null,
  userId: number | null,
  canAddInterval: boolean,
};
const initialState: MeetingsState = {
  items: [],
  page: 1,
  specialPage: 0,
  loading: true,
  count: 0,
  tenantId: null,
  userId: null,
  canAddInterval: true,
};

export const meetingsSlice = createSlice({
  name: 'meetings',
  initialState,
  reducers: {
    setItems: (state, action: PayloadAction<Array<MeetingDetailItemObject>>) => {
      state.items = action.payload;
    },
    setSpecialPage: (state, action: PayloadAction<number>) => {
      state.specialPage = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setCount: (state, action: PayloadAction<number>) => {
      state.count = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setTenantId: (state, action: PayloadAction<number>) => {
      state.tenantId = action.payload;
    },
    setUserId: (state, action: PayloadAction<number>) => {
      state.userId = action.payload;
    },
    setCanAddInterval: (state, action: PayloadAction<boolean>) => {
      state.canAddInterval = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setItems,
  setLoading,
  setPage,
  setSpecialPage,
  setCount,
  setTenantId,
  setUserId,
  setCanAddInterval,
} = meetingsSlice.actions;

export default meetingsSlice.reducer;